module.exports = __webpack_public_path__ + "static/media/fcbk-icon.08584163.png";